import { translateDefaultEntity } from "utilities/localesUtilities";
import { useRCAHistoryMainStyles } from "../../RCA.styles";
import { DefaultTranslationFieldsInTable } from "constants/constants";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { IPriority } from "entities/RCA/PriorityEntity/PriorityEntityInterfaces";

export const RCAPriorityChangeLog = ({
    oldPriority,
    newPriority,
}: {
    oldPriority?: IPriority;
    newPriority?: IPriority;
}) => {
    const classes = useRCAHistoryMainStyles();
    const { i18n } = useTranslation();

    return (
        <div className={classes.historyChangeWrapper}>
            <span className={classes.historyText}>
                {translateDefaultEntity(i18n.language, oldPriority, "name", DefaultTranslationFieldsInTable.PRIORITY)}
            </span>
            <ArrowForwardIcon />
            <span className={classes.historyText}>
                {translateDefaultEntity(i18n.language, newPriority, "name", DefaultTranslationFieldsInTable.PRIORITY)}
            </span>
        </div>
    );
};
